export const initHomeMobileAccordionSwiper = () => {
  const mainWrapper = document.querySelector(".mobile-slider-home");

  if (!mainWrapper || window.innerWidth >= 992 || !window.SwiperGlobal) return;
  if (mainWrapper.classList.contains("swiper-initialized")) return;

  mainWrapper.classList.add("swiper");

  const swiperWrapper = document.createElement("div");
  swiperWrapper.classList.add("swiper-wrapper");

  const allAccordions = mainWrapper.querySelectorAll(
    ".accordion-blob-container",
  );

  if (allAccordions.length === 0) return;

  allAccordions.forEach((accordion) => {
    accordion.classList.add("swiper-slide");
    swiperWrapper.appendChild(accordion);
  });

  mainWrapper.innerHTML = "";
  mainWrapper.appendChild(swiperWrapper);

  const prevBtn = document.createElement("div");
  prevBtn.classList.add("swiper-button-prev", "swiper-button-prev-columns");
  mainWrapper.appendChild(prevBtn);

  const nextBtn = document.createElement("div");
  nextBtn.classList.add("swiper-button-next", "swiper-button-next-columns");
  mainWrapper.appendChild(nextBtn);

  new window.SwiperGlobal(mainWrapper, {
    slidesPerView: 1.2,
    spaceBetween: 16,
    grabCursor: true,
    // navigation: {
    //   nextEl: nextBtn,
    //   prevEl: prevBtn,
    // },

    breakpoints: {
      992: {
        enabled: false,
      },
    },
  });
};
export const initAccordionBlobWrapperSwiper = () => {
  const mainWrappers = document.querySelectorAll(
    ".accordion-gallery-main-wrapper",
  );

  if (!mainWrappers.length || !window.SwiperGlobal) return;

  mainWrappers.forEach((mainParent) => {
    const isMobileSliderActive =
      mainParent.getAttribute("data-slider-mobile") === "true";
    if (!isMobileSliderActive) return;

    const accordionColumn = mainParent.querySelector(".accordion-column");
    if (
      !accordionColumn ||
      accordionColumn.classList.contains("swiper-initialized")
    )
      return;

    accordionColumn.classList.add("swiper");

    const swiperWrapper = document.createElement("div");
    swiperWrapper.classList.add("swiper-wrapper");

    const slides = Array.from(
      accordionColumn.querySelectorAll(".accordion-blob-container"),
    );

    slides.forEach((slide) => {
      slide.classList.add("swiper-slide");
      swiperWrapper.appendChild(slide);
    });

    accordionColumn.innerHTML = "";
    accordionColumn.appendChild(swiperWrapper);

    const prevBtn = document.createElement("div");
    prevBtn.classList.add(
      "swiper-button-prev",
      "swiper-button-prev-columns",
      "d-lg-none",
    );
    accordionColumn.appendChild(prevBtn);

    const nextBtn = document.createElement("div");
    nextBtn.classList.add(
      "swiper-button-next",
      "swiper-button-next-columns",
      "d-lg-none",
    );
    accordionColumn.appendChild(nextBtn);

    new window.SwiperGlobal(accordionColumn, {
      slidesPerView: 1.2,
      spaceBetween: 16,
      grabCursor: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      // navigation: {
      //   nextEl: nextBtn,
      //   prevEl: prevBtn,
      // },
      breakpoints: {
        992: {
          enabled: false,
        },
      },
    });
  });
};
export const initGutenbergColumnSwiper = () => {
  const parents = document.querySelectorAll(".gb-swiper-columns");

  if (!parents.length || !window.SwiperGlobal) return;

  parents.forEach((parent) => {
    if (parent.classList.contains("swiper-initialized")) return;

    parent.classList.add("swiper");

    const wrapper = document.createElement("div");
    wrapper.classList.add("swiper-wrapper");

    const children = Array.from(parent.children);
    children.forEach((child) => {
      child.classList.add("swiper-slide");
      wrapper.appendChild(child);
    });

    parent.appendChild(wrapper);
    const prevBtn = document.createElement("div");
    prevBtn.classList.add("swiper-button-prev", "swiper-button-prev-columns");
    parent.appendChild(prevBtn);

    const nextBtn = document.createElement("div");
    nextBtn.classList.add("swiper-button-next", "swiper-button-next-columns");
    parent.appendChild(nextBtn);

    let paginationEl = parent.querySelector(".swiper-pagination");
    if (!paginationEl) {
      paginationEl = document.createElement("div");
      paginationEl.classList.add("swiper-pagination", "d-lg-none");
      parent.appendChild(paginationEl);
    }

    new window.SwiperGlobal(parent, {
      slidesPerView: "auto",
      spaceBetween: false,
      grabCursor: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,

      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },

      breakpoints: {
        992: {
          enabled: false,
        },
      },
    });
  });
};
export const initGutenbergSwiper = () => {
  const parents = document.querySelectorAll(".gb-swiper-mobile");

  if (!parents.length || !window.SwiperGlobal) return;

  parents.forEach((parent) => {
    if (parent.classList.contains("swiper-initialized")) return;

    parent.classList.add("swiper");

    const wrapper = document.createElement("div");
    wrapper.classList.add("swiper-wrapper");

    const children = Array.from(parent.children);
    children.forEach((child) => {
      child.classList.add("swiper-slide");
      wrapper.appendChild(child);
    });

    parent.appendChild(wrapper);

    let paginationEl = parent.querySelector(".swiper-pagination");
    if (!paginationEl) {
      paginationEl = document.createElement("div");
      paginationEl.classList.add("swiper-pagination", "d-lg-none");
      parent.appendChild(paginationEl);
    }

    new window.SwiperGlobal(parent, {
      slidesPerView: "auto",
      spaceBetween: false,
      grabCursor: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      pagination: false,
      breakpoints: {
        992: {
          enabled: false,
        },
      },
    });
  });
};
export const initGutenbergSwiperTechnology = () => {
  const parents = document.querySelectorAll(".gb-swiper-mobile-technology");

  if (!parents.length || !window.SwiperGlobal) return;

  parents.forEach((parent) => {
    if (parent.classList.contains("swiper-initialized")) return;

    parent.classList.add("swiper");

    const wrapper = document.createElement("div");
    wrapper.classList.add("swiper-wrapper");

    const children = Array.from(parent.children);
    children.forEach((child) => {
      child.classList.add("swiper-slide");
      wrapper.appendChild(child);
    });

    parent.appendChild(wrapper);

    let paginationEl = parent.querySelector(".swiper-pagination");
    if (!paginationEl) {
      paginationEl = document.createElement("div");
      paginationEl.classList.add("swiper-pagination", "d-lg-none");
      parent.appendChild(paginationEl);
    }

    new window.SwiperGlobal(parent, {
      slidesPerView: 1.2,
      spaceBetween: 12,
      grabCursor: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      pagination: false,
      breakpoints: {
        992: {
          enabled: false,
        },
      },
    });
  });
};
export const initGutenbergLogosMarquee = () => {
  if (window.innerWidth > 991) return;

  const galleries = document.querySelectorAll(".logos-gallery");
  if (!galleries.length) return;

  galleries.forEach((gallery) => {
    if (gallery.classList.contains("marquee-initialized")) return;
    gallery.classList.add("marquee-initialized");

    const track = document.createElement("div");
    track.classList.add("marquee-track");

    const items = Array.from(gallery.children);
    items.forEach((item) => track.appendChild(item));

    const clone = track.cloneNode(true);
    clone.setAttribute("aria-hidden", "true");

    gallery.innerHTML = "";
    gallery.appendChild(track);
    gallery.appendChild(clone);
  });
};

export const initTechNavMobileSwiper = () => {
  // Szukamy Twojego głównego kontenera nawigacji
  const mainWrapper = document.querySelector(".tech-nav");

  // Warunki stopu: brak elementu, desktop, lub brak biblioteki Swiper
  if (!mainWrapper || window.innerWidth >= 992 || !window.SwiperGlobal) return;
  if (mainWrapper.classList.contains("swiper-initialized")) return;

  // Usuwamy na mobile klasy Bootstrapa, które blokują przewijanie w bok,
  // i dodajemy klasę główną Swipera
  mainWrapper.classList.remove("justify-content-center", "flex-wrap");
  mainWrapper.classList.add("swiper");

  // Tworzymy wymagany przez Swiper kontener na slajdy
  const swiperWrapper = document.createElement("div");
  swiperWrapper.classList.add("swiper-wrapper");

  // Pobieramy wszystkie przyciski-taby
  const allTabs = mainWrapper.querySelectorAll(".tab-btn");

  if (allTabs.length === 0) return;

  // Każdy przycisk owijamy w div o klasie "swiper-slide"
  allTabs.forEach((tab) => {
    const slide = document.createElement("div");
    slide.classList.add("swiper-slide");
    // Dodajemy styl inline do slajdu, aby dopasowywał się do szerokości przycisku
    slide.style.width = "auto";

    // Przenosimy przycisk do slajdu
    slide.appendChild(tab);
    // Slajd wrzucamy do wrappera
    swiperWrapper.appendChild(slide);
  });

  // Czyścimy stary HTML wewnątrz .tech-nav i wrzucamy nową strukturę Swipera
  mainWrapper.innerHTML = "";
  mainWrapper.appendChild(swiperWrapper);

  // Inicjalizacja Swipera
  new window.SwiperGlobal(mainWrapper, {
    slidesPerView: "auto", // Przyciski zachowają swoją szerokość (dzięki white-space: nowrap)
    spaceBetween: 12, // Odstęp między przyciskami na mobile (odpowiednik gap-3)
    grabCursor: true,
    freeMode: true, // Pozwala na płynne przewijanie palcem jak listy
    breakpoints: {
      992: {
        enabled: false, // Wyłącza Swiper na desktopie
      },
    },
  });
};
